var map = {
	"./App": 10066,
	"./App.vue": 10066,
	"./assets/css/anim.scss": 87324,
	"./assets/css/common.scss": 23425,
	"./assets/css/global.scss": 51229,
	"./assets/css/loading.scss": 30407,
	"./assets/css/reset.scss": 35634,
	"./assets/css/utils.scss": 4918,
	"./assets/fonts/AHKIO LIGHT.OTF": 21821,
	"./assets/fonts/HARMONYOS_SANS_BOLD.TTF": 35981,
	"./assets/fonts/HARMONYOS_SANS_MEDIUM.TTF": 14514,
	"./assets/fonts/HARMONYOS_SANS_REGULAR.TTF": 39773,
	"./assets/fonts/font.css": 92461,
	"./assets/icons": 17258,
	"./assets/icons/": 17258,
	"./assets/icons/index": 17258,
	"./assets/icons/index.js": 17258,
	"./assets/icons/svg/icon-arrow.svg": 51089,
	"./assets/icons/svg/icon-close.svg": 50829,
	"./assets/icons/svg/icon-copy.svg": 54171,
	"./assets/icons/svg/icon-edit.svg": 47766,
	"./assets/icons/svg/icon-getgems.svg": 45472,
	"./assets/icons/svg/icon-lfg.svg": 54012,
	"./assets/icons/svg/icon-lock.svg": 20111,
	"./assets/icons/svg/icon-log.svg": 90943,
	"./assets/icons/svg/icon-ok.svg": 35686,
	"./assets/icons/svg/icon-ok1.svg": 43440,
	"./assets/icons/svg/icon-ok2.svg": 71008,
	"./assets/icons/svg/icon-quest.svg": 62711,
	"./assets/icons/svg/icon-refresh.svg": 82037,
	"./assets/icons/svg/icon-refresh2.svg": 44627,
	"./assets/icons/svg/icon-rightarrow.svg": 90883,
	"./assets/icons/svg/icon-share.svg": 71820,
	"./assets/icons/svg/icon-sigh.svg": 34383,
	"./assets/icons/svg/icon-spin.svg": 4173,
	"./assets/icons/svg/icon-telegram.svg": 45810,
	"./assets/icons/svg/icon-user.svg": 8639,
	"./assets/images/tapcoin/30tip.png": 85750,
	"./assets/images/tapcoin/BIGTON.png": 92775,
	"./assets/images/tapcoin/TONwallet.png": 1280,
	"./assets/images/tapcoin/activity-top.png": 81522,
	"./assets/images/tapcoin/airdrop-big.png": 86780,
	"./assets/images/tapcoin/airdrop-channel.png": 85745,
	"./assets/images/tapcoin/airdrop-freemint.png": 44746,
	"./assets/images/tapcoin/airdrop-icons.png": 92227,
	"./assets/images/tapcoin/airdrop-left-bg.jpg": 67310,
	"./assets/images/tapcoin/airdrop-ok.png": 2664,
	"./assets/images/tapcoin/airdrop-pass.png": 64079,
	"./assets/images/tapcoin/airdrop-right-bg.jpg": 78149,
	"./assets/images/tapcoin/airdrop-tap-icon1.png": 65994,
	"./assets/images/tapcoin/airdrop-tap-icon2.png": 43121,
	"./assets/images/tapcoin/airdrop-tap-icon3.png": 57056,
	"./assets/images/tapcoin/airdrop-tap-icon4.png": 86026,
	"./assets/images/tapcoin/airdrop-tap-icon5.png": 48587,
	"./assets/images/tapcoin/airdrop-tap-icon6.png": 75609,
	"./assets/images/tapcoin/airdrop-tap-r2-icon1.png": 85316,
	"./assets/images/tapcoin/airdrop-tap-r2-icon10.png": 96393,
	"./assets/images/tapcoin/airdrop-tap-r2-icon2.png": 50368,
	"./assets/images/tapcoin/airdrop-tap-r2-icon3.png": 7814,
	"./assets/images/tapcoin/airdrop-tap-r2-icon4.png": 69763,
	"./assets/images/tapcoin/airdrop-tap-r2-icon5.png": 77241,
	"./assets/images/tapcoin/airdrop-tap-r2-icon6.png": 84846,
	"./assets/images/tapcoin/airdrop-tap-r2-icon7.png": 94372,
	"./assets/images/tapcoin/airdrop-tap-r2-icon8.png": 97645,
	"./assets/images/tapcoin/airdrop-tap-r2-icon9.png": 24860,
	"./assets/images/tapcoin/airdrop-tickets.png": 74318,
	"./assets/images/tapcoin/airdrop-top-bg.png": 59515,
	"./assets/images/tapcoin/airdrop-wallet.png": 70284,
	"./assets/images/tapcoin/airdrop.png": 73971,
	"./assets/images/tapcoin/award.png": 78171,
	"./assets/images/tapcoin/award_tip.jpg": 35234,
	"./assets/images/tapcoin/bitget.jpg": 1329,
	"./assets/images/tapcoin/bnb_logo.png": 62243,
	"./assets/images/tapcoin/boost-list-icon-1.png": 15035,
	"./assets/images/tapcoin/boost-list-icon-2.png": 72043,
	"./assets/images/tapcoin/boost-list-icon-3.png": 43444,
	"./assets/images/tapcoin/boost-list-icon-4.png": 4681,
	"./assets/images/tapcoin/boost-list-icon-5.png": 67241,
	"./assets/images/tapcoin/boost-list-icon-6.png": 2970,
	"./assets/images/tapcoin/browser.png": 22461,
	"./assets/images/tapcoin/btn-icon-boost.png": 97498,
	"./assets/images/tapcoin/btn-icon-frens.png": 39246,
	"./assets/images/tapcoin/code-icon-0.png": 2913,
	"./assets/images/tapcoin/comingsoon.jpg": 16199,
	"./assets/images/tapcoin/daily-invite.png": 49729,
	"./assets/images/tapcoin/daily_icon.png": 29094,
	"./assets/images/tapcoin/diamond.png": 97669,
	"./assets/images/tapcoin/earn-btn-bg.jpg": 55343,
	"./assets/images/tapcoin/earn-head-icon-gift.png": 59216,
	"./assets/images/tapcoin/earn-icon-0.png": 43847,
	"./assets/images/tapcoin/earn-key.png": 50899,
	"./assets/images/tapcoin/earn-list-icon-1.png": 349,
	"./assets/images/tapcoin/earn-list-icon-2.png": 45090,
	"./assets/images/tapcoin/earn-list-icon-gift.png": 95596,
	"./assets/images/tapcoin/earn-logo.png": 44577,
	"./assets/images/tapcoin/finish.png": 26059,
	"./assets/images/tapcoin/frens-1.png": 44604,
	"./assets/images/tapcoin/frens-2.png": 32854,
	"./assets/images/tapcoin/frens-3.png": 28306,
	"./assets/images/tapcoin/game/2048/icon.jpg": 89870,
	"./assets/images/tapcoin/game/aaGame/icon.jpg": 93278,
	"./assets/images/tapcoin/game/bubbleShooter/icon.jpg": 59583,
	"./assets/images/tapcoin/game/circleMerge/icon.jpg": 86499,
	"./assets/images/tapcoin/game/fruitRush/1.png": 34337,
	"./assets/images/tapcoin/game/fruitRush/2.png": 17306,
	"./assets/images/tapcoin/game/fruitRush/3.png": 74949,
	"./assets/images/tapcoin/game/fruitRush/4.png": 43352,
	"./assets/images/tapcoin/game/fruitRush/5.png": 98644,
	"./assets/images/tapcoin/game/fruitRush/6.png": 4334,
	"./assets/images/tapcoin/game/fruitRush/7.png": 75172,
	"./assets/images/tapcoin/game/fruitRush/bg.png": 62762,
	"./assets/images/tapcoin/game/fruitRush/icon.jpg": 39399,
	"./assets/images/tapcoin/game/poptop.png": 1644,
	"./assets/images/tapcoin/game/sheep/1.png": 18067,
	"./assets/images/tapcoin/game/sheep/2.png": 96866,
	"./assets/images/tapcoin/game/sheep/3.png": 67476,
	"./assets/images/tapcoin/game/sheep/4.png": 2845,
	"./assets/images/tapcoin/game/sheep/5.png": 77326,
	"./assets/images/tapcoin/game/sheep/6.png": 5203,
	"./assets/images/tapcoin/game/sheep/7.png": 99219,
	"./assets/images/tapcoin/game/sheep/8.png": 31344,
	"./assets/images/tapcoin/game/sheep/9.png": 28247,
	"./assets/images/tapcoin/game/sheep/icon.jpg": 254,
	"./assets/images/tapcoin/game/tapUp/icon.jpg": 66677,
	"./assets/images/tapcoin/game/tileConnect/icon.jpg": 30526,
	"./assets/images/tapcoin/game/zenBlocks/icon.jpg": 2751,
	"./assets/images/tapcoin/gate.jpg": 94279,
	"./assets/images/tapcoin/icon-frens.png": 93011,
	"./assets/images/tapcoin/icon-pph-1.png": 37825,
	"./assets/images/tapcoin/icon-pph-2.png": 42220,
	"./assets/images/tapcoin/index-bg-1.jpg": 62848,
	"./assets/images/tapcoin/index-bg.jpg": 63156,
	"./assets/images/tapcoin/index-btn-activity.png": 76101,
	"./assets/images/tapcoin/index-btn-airdrop.png": 21553,
	"./assets/images/tapcoin/index-btn-appcenter.png": 22110,
	"./assets/images/tapcoin/index-btn-boost.png": 30586,
	"./assets/images/tapcoin/index-btn-earn.png": 3263,
	"./assets/images/tapcoin/index-btn-frens.png": 94744,
	"./assets/images/tapcoin/index-btn-home.png": 20638,
	"./assets/images/tapcoin/index-btn-icon-1.png": 36013,
	"./assets/images/tapcoin/index-btn-icon-2.png": 7031,
	"./assets/images/tapcoin/index-btn-icon-21.png": 12586,
	"./assets/images/tapcoin/index-btn-icon-3.png": 64551,
	"./assets/images/tapcoin/index-btn-icon-4.png": 66708,
	"./assets/images/tapcoin/index-btn-lottery.png": 95357,
	"./assets/images/tapcoin/index-btn-mine.png": 6368,
	"./assets/images/tapcoin/index-btn-wallet.png": 46198,
	"./assets/images/tapcoin/index-c-btn-bg.png": 80124,
	"./assets/images/tapcoin/index-icon-big-coin.png": 57569,
	"./assets/images/tapcoin/index-icon-bronze.png": 45580,
	"./assets/images/tapcoin/index-icon-energy.png": 58052,
	"./assets/images/tapcoin/index-icon-level.png": 75009,
	"./assets/images/tapcoin/index-icon-pph.png": 76938,
	"./assets/images/tapcoin/index-icon-small-coin.png": 68841,
	"./assets/images/tapcoin/index-icon-squad-1.png": 98556,
	"./assets/images/tapcoin/index-icon-squad.png": 21273,
	"./assets/images/tapcoin/index-icon-wallet.png": 82472,
	"./assets/images/tapcoin/inset-bg-1.jpg": 88991,
	"./assets/images/tapcoin/inset-bg.jpg": 62836,
	"./assets/images/tapcoin/join-icon-frens.png": 25786,
	"./assets/images/tapcoin/lbank.jpg": 87678,
	"./assets/images/tapcoin/level/Bronze.png": 81649,
	"./assets/images/tapcoin/level/Diamond.png": 17308,
	"./assets/images/tapcoin/level/Emerald.png": 39975,
	"./assets/images/tapcoin/level/Gold.png": 88027,
	"./assets/images/tapcoin/level/Platinum.png": 96604,
	"./assets/images/tapcoin/level/Ruby.png": 29676,
	"./assets/images/tapcoin/level/Silver.png": 97004,
	"./assets/images/tapcoin/level/Wish.png": 85792,
	"./assets/images/tapcoin/loading.gif": 28272,
	"./assets/images/tapcoin/lock.png": 72193,
	"./assets/images/tapcoin/logo.png": 94623,
	"./assets/images/tapcoin/lottery-icon.png": 55375,
	"./assets/images/tapcoin/luckcode.png": 49349,
	"./assets/images/tapcoin/lucky/3245.jpg": 83401,
	"./assets/images/tapcoin/lucky/gift-bg.png": 46974,
	"./assets/images/tapcoin/lucky/giftLuckyBanner.jpg": 34920,
	"./assets/images/tapcoin/lucky/icon-star.png": 36281,
	"./assets/images/tapcoin/lucky/icon-star2.png": 16558,
	"./assets/images/tapcoin/lucky/key.png": 64765,
	"./assets/images/tapcoin/lucky/light1-gift.png": 6530,
	"./assets/images/tapcoin/lucky/light1.png": 94421,
	"./assets/images/tapcoin/lucky/light2-gift.png": 88083,
	"./assets/images/tapcoin/lucky/light2.png": 73133,
	"./assets/images/tapcoin/lucky/lucky-bg.jpg": 85774,
	"./assets/images/tapcoin/lucky/lucky-btn-bg.png": 2548,
	"./assets/images/tapcoin/lucky/lucky-btn2.png": 50982,
	"./assets/images/tapcoin/lucky/lucky-item-bg-gift.png": 73161,
	"./assets/images/tapcoin/lucky/lucky-item-bg.png": 48012,
	"./assets/images/tapcoin/lucky/lucky-result-coin-tap.png": 55788,
	"./assets/images/tapcoin/lucky/lucky-result-coin-tapcoins.png": 16414,
	"./assets/images/tapcoin/lucky/lucky-result-coin-tapstock.png": 43375,
	"./assets/images/tapcoin/lucky/lucky-result-coin-ton.png": 82649,
	"./assets/images/tapcoin/lucky/lucky-result-coin-usdt.png": 11104,
	"./assets/images/tapcoin/lucky/lucky-result-light.png": 60268,
	"./assets/images/tapcoin/lucky/tap.png": 35092,
	"./assets/images/tapcoin/lucky/tapcoins.png": 78565,
	"./assets/images/tapcoin/lucky/tapgiftshard.png": 31965,
	"./assets/images/tapcoin/lucky/ton.png": 52808,
	"./assets/images/tapcoin/lucky/usdEventBanner.jpg": 96346,
	"./assets/images/tapcoin/lucky/usdt.png": 5976,
	"./assets/images/tapcoin/luckybox/bought-bg.png": 77765,
	"./assets/images/tapcoin/luckybox/box/1.png": 74891,
	"./assets/images/tapcoin/luckybox/box/11.png": 30398,
	"./assets/images/tapcoin/luckybox/box/2.png": 59330,
	"./assets/images/tapcoin/luckybox/box/21.png": 87336,
	"./assets/images/tapcoin/luckybox/box/3.png": 11363,
	"./assets/images/tapcoin/luckybox/box/31.png": 16370,
	"./assets/images/tapcoin/luckybox/box/4.png": 1188,
	"./assets/images/tapcoin/luckybox/box/41.png": 85447,
	"./assets/images/tapcoin/luckybox/box/5.png": 92037,
	"./assets/images/tapcoin/luckybox/box/51.png": 51508,
	"./assets/images/tapcoin/luckybox/box/6.png": 21910,
	"./assets/images/tapcoin/luckybox/box/61.png": 90135,
	"./assets/images/tapcoin/luckybox/leaderboard.png": 32395,
	"./assets/images/tapcoin/luckybox/luckybox-hd.png": 76390,
	"./assets/images/tapcoin/luckybox/luckybox-hd1.png": 81015,
	"./assets/images/tapcoin/luckybox/luckybox-item-bg.png": 39889,
	"./assets/images/tapcoin/luckybox/records.png": 2017,
	"./assets/images/tapcoin/menu-bg.png": 5620,
	"./assets/images/tapcoin/mexc.jpg": 95897,
	"./assets/images/tapcoin/new/30tip.png": 10411,
	"./assets/images/tapcoin/new/CRY.png": 61764,
	"./assets/images/tapcoin/new/TAP-small.png": 24460,
	"./assets/images/tapcoin/new/TAP.png": 63297,
	"./assets/images/tapcoin/new/TAPCOINS-small.png": 9474,
	"./assets/images/tapcoin/new/TAPCOINS.png": 12129,
	"./assets/images/tapcoin/new/TAPSTOCK-small.png": 12337,
	"./assets/images/tapcoin/new/TAPSTOCK.png": 68715,
	"./assets/images/tapcoin/new/TON.png": 5418,
	"./assets/images/tapcoin/new/USDT-small.png": 4943,
	"./assets/images/tapcoin/new/USDT.png": 56595,
	"./assets/images/tapcoin/new/avatar/avatar-1.png": 24774,
	"./assets/images/tapcoin/new/avatar/avatar-2.png": 93337,
	"./assets/images/tapcoin/new/avatar/avatar-3.png": 2025,
	"./assets/images/tapcoin/new/avatar/avatar-4.png": 28018,
	"./assets/images/tapcoin/new/avatar/avatar-5.png": 25571,
	"./assets/images/tapcoin/new/avatar/index-bg-basic.jpg": 24435,
	"./assets/images/tapcoin/new/avatar/index-bg-basic1.jpg": 8801,
	"./assets/images/tapcoin/new/avatar/index-bg-basic2.jpg": 26331,
	"./assets/images/tapcoin/new/blind/bind-box.png": 16670,
	"./assets/images/tapcoin/new/blind/bind-item-bg.jpg": 67404,
	"./assets/images/tapcoin/new/blind/bind-select.png": 31329,
	"./assets/images/tapcoin/new/blind/blind-container-bg.png": 65899,
	"./assets/images/tapcoin/new/blind/blind-items-board.png": 29146,
	"./assets/images/tapcoin/new/blind/reward-box.png": 39264,
	"./assets/images/tapcoin/new/blind/reward-select.png": 6608,
	"./assets/images/tapcoin/new/btn-scan.jpg": 77336,
	"./assets/images/tapcoin/new/fortune/banner.jpg": 61632,
	"./assets/images/tapcoin/new/fortune/fortune-card-Bgblack.png": 99231,
	"./assets/images/tapcoin/new/fortune/fortune-card-Bgblue.png": 8874,
	"./assets/images/tapcoin/new/fortune/fortune-card-Bggreen.png": 6509,
	"./assets/images/tapcoin/new/fortune/fortune-card-Bgorange.png": 61242,
	"./assets/images/tapcoin/new/fortune/fortune-card-Bgpink.png": 62714,
	"./assets/images/tapcoin/new/fortune/fortune-card-Bgred.png": 72867,
	"./assets/images/tapcoin/new/fortune/fortune-card-Bgyellow.png": 78053,
	"./assets/images/tapcoin/new/fortune/fortune-card-light.png": 53154,
	"./assets/images/tapcoin/new/fortune/fortune-card.png": 35108,
	"./assets/images/tapcoin/new/fortune/forturn-star.png": 97267,
	"./assets/images/tapcoin/new/fortune/forturn-synthesis-bg.jpg": 21710,
	"./assets/images/tapcoin/new/fortune/forturn-tag.png": 87539,
	"./assets/images/tapcoin/new/fortune/orturn-synthesis-empty.png": 85965,
	"./assets/images/tapcoin/new/game-small.png": 76050,
	"./assets/images/tapcoin/new/game.jpeg": 4668,
	"./assets/images/tapcoin/new/gift-selector-997.png": 94592,
	"./assets/images/tapcoin/new/gift-selector-arrow-997.png": 17144,
	"./assets/images/tapcoin/new/gift-selector-arrow.png": 53981,
	"./assets/images/tapcoin/new/gift-selector.png": 21226,
	"./assets/images/tapcoin/new/gift/gift-exclusise-img.png": 89505,
	"./assets/images/tapcoin/new/gift/gift-high-img.png": 11073,
	"./assets/images/tapcoin/new/gift/gift-img.jpg": 70129,
	"./assets/images/tapcoin/new/hot.png": 3785,
	"./assets/images/tapcoin/new/icon-diamond.png": 93365,
	"./assets/images/tapcoin/new/icon-gold-1.png": 22444,
	"./assets/images/tapcoin/new/icon-group.png": 76515,
	"./assets/images/tapcoin/new/icon-menu.png": 70354,
	"./assets/images/tapcoin/new/icon-ok.png": 37674,
	"./assets/images/tapcoin/new/icon-people.png": 74432,
	"./assets/images/tapcoin/new/icon-profit.png": 67918,
	"./assets/images/tapcoin/new/icon-ranking.png": 98853,
	"./assets/images/tapcoin/new/icon-wallet.png": 16864,
	"./assets/images/tapcoin/new/index-bg-gold.png": 33292,
	"./assets/images/tapcoin/new/index-icon-boosts.png": 38663,
	"./assets/images/tapcoin/new/index-icon-crypto.png": 91607,
	"./assets/images/tapcoin/new/index-icon-frens.png": 67993,
	"./assets/images/tapcoin/new/index-icon-progress.png": 59021,
	"./assets/images/tapcoin/new/index-icon-slots.png": 4282,
	"./assets/images/tapcoin/new/index-icon-spin.png": 50241,
	"./assets/images/tapcoin/new/lock/avatar-lock-bg.jpg": 92930,
	"./assets/images/tapcoin/new/lock/avatar-lock-l.png": 76149,
	"./assets/images/tapcoin/new/lock/avatar-lock-s.png": 5386,
	"./assets/images/tapcoin/new/lock/double_p.png": 45844,
	"./assets/images/tapcoin/new/lock/gift-1.png": 43010,
	"./assets/images/tapcoin/new/lock/gift-2.png": 69894,
	"./assets/images/tapcoin/new/lock/gift-3.png": 37356,
	"./assets/images/tapcoin/new/machine/machine-arrow.png": 17336,
	"./assets/images/tapcoin/new/machine/machine-bg.png": 5455,
	"./assets/images/tapcoin/new/machine/machine-btn1-bg-1.png": 29058,
	"./assets/images/tapcoin/new/machine/machine-btn1-bg.png": 87662,
	"./assets/images/tapcoin/new/machine/machine-btn2-bg-1.png": 73990,
	"./assets/images/tapcoin/new/machine/machine-btn2-bg.png": 60726,
	"./assets/images/tapcoin/new/machine/machine-main-bg.png": 92956,
	"./assets/images/tapcoin/new/machine/machine-page-bg.jpg": 13637,
	"./assets/images/tapcoin/new/machine/machine-title.png": 39551,
	"./assets/images/tapcoin/new/menu-active-bg.png": 36962,
	"./assets/images/tapcoin/new/menu-airdrop-active.png": 84387,
	"./assets/images/tapcoin/new/menu-airdrop.png": 19842,
	"./assets/images/tapcoin/new/menu-app-active.png": 2627,
	"./assets/images/tapcoin/new/menu-app.png": 93024,
	"./assets/images/tapcoin/new/menu-bg.png": 48030,
	"./assets/images/tapcoin/new/menu-earn-active.png": 35656,
	"./assets/images/tapcoin/new/menu-earn.png": 78194,
	"./assets/images/tapcoin/new/menu-game-active.png": 57508,
	"./assets/images/tapcoin/new/menu-game.png": 31929,
	"./assets/images/tapcoin/new/menu-gift-active.png": 10321,
	"./assets/images/tapcoin/new/menu-gift.png": 47003,
	"./assets/images/tapcoin/new/menu-home-active.png": 11681,
	"./assets/images/tapcoin/new/menu-home.png": 30399,
	"./assets/images/tapcoin/new/menu-nft-active.png": 4654,
	"./assets/images/tapcoin/new/menu-nft.png": 86814,
	"./assets/images/tapcoin/new/menu-study-active.png": 63565,
	"./assets/images/tapcoin/new/menu-study.png": 53568,
	"./assets/images/tapcoin/new/menu-tasks-active.png": 27283,
	"./assets/images/tapcoin/new/menu-tasks.png": 23570,
	"./assets/images/tapcoin/new/mpay-intro.jpg": 64877,
	"./assets/images/tapcoin/new/mpay-logo.png": 34077,
	"./assets/images/tapcoin/new/mpay.jpg": 56947,
	"./assets/images/tapcoin/new/mpayBanner-1.jpg": 30887,
	"./assets/images/tapcoin/new/mpayBanner.jpg": 22784,
	"./assets/images/tapcoin/new/mpayBanner__title.png": 70369,
	"./assets/images/tapcoin/new/nav-bg.jpg": 77843,
	"./assets/images/tapcoin/new/nav-icon-achievements.png": 96289,
	"./assets/images/tapcoin/new/nav-icon-bounty.png": 18689,
	"./assets/images/tapcoin/new/nav-icon-code.png": 4169,
	"./assets/images/tapcoin/new/nav-icon-login.png": 82097,
	"./assets/images/tapcoin/new/new.png": 76794,
	"./assets/images/tapcoin/new/nft-balance.jpg": 80803,
	"./assets/images/tapcoin/new/nftInfo/nftInfo-banner.jpg": 61136,
	"./assets/images/tapcoin/new/nftInfo/nftInfo-footer.jpg": 95409,
	"./assets/images/tapcoin/new/nftInfo/nftInfo-items-bg.png": 8757,
	"./assets/images/tapcoin/new/nftInfo/nftInfo-me.jpg": 96286,
	"./assets/images/tapcoin/new/niceLucky/btn-1.png": 70699,
	"./assets/images/tapcoin/new/niceLucky/btn-2.png": 72564,
	"./assets/images/tapcoin/new/niceLucky/icon-buy.png": 77947,
	"./assets/images/tapcoin/new/niceLucky/icon-invite.png": 15850,
	"./assets/images/tapcoin/new/niceLucky/icon-shard.png": 82170,
	"./assets/images/tapcoin/new/niceLucky/icon-ship.png": 54684,
	"./assets/images/tapcoin/new/niceLucky/icon-task.png": 53731,
	"./assets/images/tapcoin/new/niceLucky/light.png": 22540,
	"./assets/images/tapcoin/new/niceLucky/nft-bg.jpg": 74418,
	"./assets/images/tapcoin/new/niceLucky/niceLucky-bottom.png": 52706,
	"./assets/images/tapcoin/new/niceLucky/niceLucky-item-active-bg.png": 26666,
	"./assets/images/tapcoin/new/niceLucky/niceLucky-item-bg.png": 53468,
	"./assets/images/tapcoin/new/niceLucky/niceLucky.png": 13243,
	"./assets/images/tapcoin/new/niceLucky/niceLucky_title.png": 2036,
	"./assets/images/tapcoin/new/niceLucky/niceLucy-bg.jpg": 57808,
	"./assets/images/tapcoin/new/niceLucky/ship-num.png": 42450,
	"./assets/images/tapcoin/new/perHour.png": 88043,
	"./assets/images/tapcoin/new/slotscomensation-banner.jpg": 37892,
	"./assets/images/tapcoin/okwallet-logo.png": 36863,
	"./assets/images/tapcoin/okx.jpg": 38297,
	"./assets/images/tapcoin/okxwallet-live.png": 52338,
	"./assets/images/tapcoin/okxwallet-top.png": 19501,
	"./assets/images/tapcoin/pop-award-icon-0.png": 79986,
	"./assets/images/tapcoin/pop-coin-hero-icon-0.png": 63230,
	"./assets/images/tapcoin/pop-up-gold-icon-0.png": 9611,
	"./assets/images/tapcoin/premium-s.png": 93685,
	"./assets/images/tapcoin/premium.png": 69018,
	"./assets/images/tapcoin/proof.jpg": 29206,
	"./assets/images/tapcoin/rank-1.png": 19162,
	"./assets/images/tapcoin/rank-2.png": 32030,
	"./assets/images/tapcoin/rank-3.png": 78368,
	"./assets/images/tapcoin/rank-bronze.png": 44222,
	"./assets/images/tapcoin/robot-logo.jpg": 52541,
	"./assets/images/tapcoin/scan-head.jpg": 40072,
	"./assets/images/tapcoin/sd.png": 18773,
	"./assets/images/tapcoin/sign-calendar-ok.png": 36468,
	"./assets/images/tapcoin/sign-calendar.png": 18976,
	"./assets/images/tapcoin/sign-premium.png": 96936,
	"./assets/images/tapcoin/solojack-tip.png": 57211,
	"./assets/images/tapcoin/squad-icon-1.png": 54583,
	"./assets/images/tapcoin/squad-icon-2.png": 44481,
	"./assets/images/tapcoin/squad-icon-3.png": 3355,
	"./assets/images/tapcoin/squad-icon-4.png": 83051,
	"./assets/images/tapcoin/start.png": 8059,
	"./assets/images/tapcoin/tap.png": 30909,
	"./assets/images/tapcoin/task-detail-arrow.png": 50056,
	"./assets/images/tapcoin/task-detail-arrow2.png": 88161,
	"./assets/images/tapcoin/task-detail-bg.jpg": 68183,
	"./assets/images/tapcoin/task-detail-step-1.jpg": 82173,
	"./assets/images/tapcoin/task-detail-step-2.jpg": 50133,
	"./assets/images/tapcoin/task-detail-step-3.jpg": 4134,
	"./assets/images/tapcoin/task-detail-step-4.jpg": 26725,
	"./assets/images/tapcoin/tickets.png": 73780,
	"./assets/images/tapcoin/time.png": 92661,
	"./assets/images/tapcoin/tip.png": 62136,
	"./assets/images/tapcoin/ton-add.png": 5929,
	"./assets/images/tapcoin/ton-stars-fill.png": 31493,
	"./assets/images/tapcoin/ton-stars.png": 92550,
	"./assets/images/tapcoin/tron.png": 89486,
	"./assets/images/tapcoin/turbo.png": 11278,
	"./assets/images/tapcoin/unknown.png": 70001,
	"./assets/images/tapcoin/up.png": 570,
	"./assets/images/tapcoin/usdt-p.png": 65984,
	"./assets/images/tapcoin/usdt.png": 44777,
	"./assets/images/tapcoin/zbx.jpg": 78155,
	"./assets/js/assetsManifest": 55715,
	"./assets/js/assetsManifest.json": 55715,
	"./assets/js/confetti": 19342,
	"./assets/js/confetti.js": 19342,
	"./assets/js/fireworkEffect": 83034,
	"./assets/js/fireworkEffect.js": 83034,
	"./assets/js/hoejs": 63964,
	"./assets/js/hoejs.js": 63964,
	"./assets/js/noZoom": 62654,
	"./assets/js/noZoom.js": 62654,
	"./assets/js/pop": 42487,
	"./assets/js/pop.js": 42487,
	"./assets/js/rem": 79633,
	"./assets/js/rem.js": 79633,
	"./components/btnBack": 71116,
	"./components/btnBack.vue": 71116,
	"./components/carousel/carousel": 11971,
	"./components/carousel/carousel.vue": 11971,
	"./components/countUp": 60886,
	"./components/countUp.vue": 60886,
	"./components/game/popGameLostPrompt": 57600,
	"./components/game/popGameLostPrompt.vue": 57600,
	"./components/game/popGameRank": 24965,
	"./components/game/popGameRank.vue": 24965,
	"./components/game/popGameStartPrompt": 69663,
	"./components/game/popGameStartPrompt.vue": 69663,
	"./components/game/popGameUserRewardPrompt": 50977,
	"./components/game/popGameUserRewardPrompt.vue": 50977,
	"./components/game/popGameWarnPrompt": 43309,
	"./components/game/popGameWarnPrompt.vue": 43309,
	"./components/game/popGameWinPrompt": 87552,
	"./components/game/popGameWinPrompt.vue": 87552,
	"./components/game/sheep/SheepSlotBarComponent": 5511,
	"./components/game/sheep/SheepSlotBarComponent.vue": 5511,
	"./components/game/sheep/SheepTileComponent": 37718,
	"./components/game/sheep/SheepTileComponent.vue": 37718,
	"./components/game/tileConnect/linkBoard": 69083,
	"./components/game/tileConnect/linkBoard.vue": 69083,
	"./components/game/tileConnect/linkTile": 94811,
	"./components/game/tileConnect/linkTile.vue": 94811,
	"./components/game/zenBlocks/MiniBlock": 91296,
	"./components/game/zenBlocks/MiniBlock.vue": 91296,
	"./components/game/zenBlocks/PlacementHint": 34380,
	"./components/game/zenBlocks/PlacementHint.vue": 34380,
	"./components/index/goldcoinIndex": 89401,
	"./components/index/goldcoinIndex.vue": 89401,
	"./components/index/memetownIndex": 35566,
	"./components/index/memetownIndex.vue": 35566,
	"./components/index/reflectionIndex": 83545,
	"./components/index/reflectionIndex.vue": 83545,
	"./components/index/tapcoinIndex": 31316,
	"./components/index/tapcoinIndex.vue": 31316,
	"./components/index/tapcoinIndexNew": 88062,
	"./components/index/tapcoinIndexNew.vue": 88062,
	"./components/layout": 1386,
	"./components/layout.vue": 1386,
	"./components/luckywheel/luckyWheel": 39571,
	"./components/luckywheel/luckyWheel.vue": 39571,
	"./components/luckywheel/luckyWheelItem": 48555,
	"./components/luckywheel/luckyWheelItem.vue": 48555,
	"./components/mHead": 9002,
	"./components/mHead.vue": 9002,
	"./components/mMenu": 13439,
	"./components/mMenu.vue": 13439,
	"./components/mPage": 94905,
	"./components/mPage.vue": 94905,
	"./components/myLoading": 59478,
	"./components/myLoading/": 59478,
	"./components/myLoading/index": 59478,
	"./components/myLoading/index.js": 59478,
	"./components/myLoading/myLoading": 65846,
	"./components/myLoading/myLoading.scss": 81925,
	"./components/myLoading/myLoading.vue": 65846,
	"./components/myTile/myTile": 9604,
	"./components/myTile/myTile.vue": 9604,
	"./components/myTile/vanilla-tilt": 81043,
	"./components/myTile/vanilla-tilt.js": 81043,
	"./components/popAchievements": 53802,
	"./components/popAchievements.vue": 53802,
	"./components/popAdvTip": 9413,
	"./components/popAdvTip.vue": 9413,
	"./components/popAirdropTapLogs": 41143,
	"./components/popAirdropTapLogs.vue": 41143,
	"./components/popAirdropTapTip": 85229,
	"./components/popAirdropTapTip.vue": 85229,
	"./components/popAirdropTicketDesc": 29817,
	"./components/popAirdropTicketDesc.vue": 29817,
	"./components/popAirdropTicketLogs": 12854,
	"./components/popAirdropTicketLogs.vue": 12854,
	"./components/popAirdropTicketTip": 32687,
	"./components/popAirdropTicketTip.vue": 32687,
	"./components/popAirdropTip": 18569,
	"./components/popAirdropTip.vue": 18569,
	"./components/popAppcenterEnergy": 69575,
	"./components/popAppcenterEnergy.vue": 69575,
	"./components/popAppcenterTipEnergy": 65360,
	"./components/popAppcenterTipEnergy.vue": 65360,
	"./components/popAward": 3727,
	"./components/popAward.vue": 3727,
	"./components/popAwardTip": 59017,
	"./components/popAwardTip.vue": 59017,
	"./components/popBindOkxWallet": 24925,
	"./components/popBindOkxWallet.vue": 24925,
	"./components/popBindWallet": 10635,
	"./components/popBindWallet.vue": 10635,
	"./components/popBioMatrixScan": 96784,
	"./components/popBioMatrixScan.vue": 96784,
	"./components/popBioMatrixScanCheck": 25112,
	"./components/popBioMatrixScanCheck.vue": 25112,
	"./components/popBioMatrixScanNext": 10032,
	"./components/popBioMatrixScanNext.vue": 10032,
	"./components/popBioMatrixScanReward": 24311,
	"./components/popBioMatrixScanReward.vue": 24311,
	"./components/popBitgetUidSubmit": 28325,
	"./components/popBitgetUidSubmit.vue": 28325,
	"./components/popCodexFieldWallet": 6174,
	"./components/popCodexFieldWallet.vue": 6174,
	"./components/popCoinHero": 63353,
	"./components/popCoinHero.vue": 63353,
	"./components/popDialog": 55014,
	"./components/popDialog.vue": 55014,
	"./components/popEarnTip": 38913,
	"./components/popEarnTip.vue": 38913,
	"./components/popEnergy": 48334,
	"./components/popEnergy.vue": 48334,
	"./components/popExtraInvite": 53033,
	"./components/popExtraInvite.vue": 53033,
	"./components/popFaceScan": 12086,
	"./components/popFaceScan.vue": 12086,
	"./components/popFaceScanLog": 80611,
	"./components/popFaceScanLog.vue": 80611,
	"./components/popFaceTip": 41244,
	"./components/popFaceTip.vue": 41244,
	"./components/popGetAward": 58511,
	"./components/popGetAward.vue": 58511,
	"./components/popGetRewardTip": 68921,
	"./components/popGetRewardTip.vue": 68921,
	"./components/popJoin": 82364,
	"./components/popJoin.vue": 82364,
	"./components/popLoginReward": 78165,
	"./components/popLoginReward.vue": 78165,
	"./components/popLotteryJoin": 99969,
	"./components/popLotteryJoin.vue": 99969,
	"./components/popLuckyboxDiamond": 5924,
	"./components/popLuckyboxDiamond.vue": 5924,
	"./components/popLuckyboxNewRound": 508,
	"./components/popLuckyboxNewRound.vue": 508,
	"./components/popLuckyboxNewTip": 52630,
	"./components/popLuckyboxNewTip.vue": 52630,
	"./components/popLuckyboxRanking": 92115,
	"./components/popLuckyboxRanking.vue": 92115,
	"./components/popLuckyboxRecords": 39703,
	"./components/popLuckyboxRecords.vue": 39703,
	"./components/popLuckyboxRecordsInfo": 10182,
	"./components/popLuckyboxRecordsInfo.vue": 10182,
	"./components/popLuckyboxTip": 62097,
	"./components/popLuckyboxTip.vue": 62097,
	"./components/popMethod": 31346,
	"./components/popMethod.vue": 31346,
	"./components/popMineEnergy": 89478,
	"./components/popMineEnergy.vue": 89478,
	"./components/popMineTip": 87957,
	"./components/popMineTip.vue": 87957,
	"./components/popNewNftDetail": 56552,
	"./components/popNewNftDetail.vue": 56552,
	"./components/popNftDetail": 72935,
	"./components/popNftDetail.vue": 72935,
	"./components/popNftShards": 68825,
	"./components/popNftShards.vue": 68825,
	"./components/popNftTask": 43063,
	"./components/popNftTask.vue": 43063,
	"./components/popPphTip": 31294,
	"./components/popPphTip.vue": 31294,
	"./components/popPrompt": 8515,
	"./components/popPrompt.vue": 8515,
	"./components/popPrompt2": 46642,
	"./components/popPrompt2.vue": 46642,
	"./components/popReward": 61580,
	"./components/popReward.vue": 61580,
	"./components/popRewardResult": 15318,
	"./components/popRewardResult.vue": 15318,
	"./components/popRobot": 22758,
	"./components/popRobot.vue": 22758,
	"./components/popSelectToken": 94940,
	"./components/popSelectToken.vue": 94940,
	"./components/popSellGift": 99826,
	"./components/popSellGift.vue": 99826,
	"./components/popShare": 16499,
	"./components/popShare.vue": 16499,
	"./components/popSign": 89670,
	"./components/popSign.vue": 89670,
	"./components/popSpecialDetail": 60002,
	"./components/popSpecialDetail.vue": 60002,
	"./components/popSquad": 1172,
	"./components/popSquad.vue": 1172,
	"./components/popStarDeposit": 47090,
	"./components/popStarDeposit.vue": 47090,
	"./components/popTipEnergy": 97211,
	"./components/popTipEnergy.vue": 97211,
	"./components/popTipTaskDetail": 71703,
	"./components/popTipTaskDetail.vue": 71703,
	"./components/popUpGold": 51856,
	"./components/popUpGold.vue": 51856,
	"./components/popUsdInvite": 84238,
	"./components/popUsdInvite.vue": 84238,
	"./components/popUsdSign": 12697,
	"./components/popUsdSign.vue": 12697,
	"./components/popWithdraw": 95542,
	"./components/popWithdraw.vue": 95542,
	"./components/popYoutube": 40711,
	"./components/popYoutube.vue": 40711,
	"./components/preloadImage": 30098,
	"./components/preloadImage.vue": 30098,
	"./components/roundLoading/roundLoading": 31922,
	"./components/roundLoading/roundLoading.vue": 31922,
	"./components/starExplosion": 64051,
	"./components/starExplosion.vue": 64051,
	"./components/svgIcon": 20239,
	"./components/svgIcon.vue": 20239,
	"./components/tapcoinNew/danmaku/danMaku": 81446,
	"./components/tapcoinNew/danmaku/danMaku.vue": 81446,
	"./components/tapcoinNew/danmaku/mDanmaku": 75337,
	"./components/tapcoinNew/danmaku/mDanmaku.vue": 75337,
	"./components/tapcoinNew/mCountUp": 83882,
	"./components/tapcoinNew/mCountUp.vue": 83882,
	"./components/tapcoinNew/nCurrency": 63429,
	"./components/tapcoinNew/nCurrency.vue": 63429,
	"./components/tapcoinNew/nCurrencyTwo": 23018,
	"./components/tapcoinNew/nCurrencyTwo.vue": 23018,
	"./components/tapcoinNew/nGiftHead": 3804,
	"./components/tapcoinNew/nGiftHead.vue": 3804,
	"./components/tapcoinNew/nHead": 64665,
	"./components/tapcoinNew/nHead.vue": 64665,
	"./components/tapcoinNew/nMenu": 55506,
	"./components/tapcoinNew/nMenu.vue": 55506,
	"./components/tapcoinNew/nNewHead": 30234,
	"./components/tapcoinNew/nNewHead.vue": 30234,
	"./components/tapcoinNew/popDoubleReward": 67364,
	"./components/tapcoinNew/popDoubleReward.vue": 67364,
	"./components/tapcoinNew/popFail": 76194,
	"./components/tapcoinNew/popFail.vue": 76194,
	"./components/tapcoinNew/popLockAvatar": 29521,
	"./components/tapcoinNew/popLockAvatar.vue": 29521,
	"./components/tapcoinNew/popRewardResultM": 67132,
	"./components/tapcoinNew/popRewardResultM.vue": 67132,
	"./components/tapcoinNew/slotMachine/mGift": 84110,
	"./components/tapcoinNew/slotMachine/mGift.vue": 84110,
	"./components/tapcoinNew/slotMachine/mSlotMachine": 40975,
	"./components/tapcoinNew/slotMachine/mSlotMachine.vue": 40975,
	"./components/uMenu": 47508,
	"./components/uMenu.vue": 47508,
	"./config": 6846,
	"./config/": 6846,
	"./config/index": 6846,
	"./config/index.js": 6846,
	"./directive": 90973,
	"./directive/": 90973,
	"./directive/direct/v-anchor": 52828,
	"./directive/direct/v-anchor.js": 52828,
	"./directive/direct/v-copy": 44404,
	"./directive/direct/v-copy.js": 44404,
	"./directive/direct/v-debounce": 64459,
	"./directive/direct/v-debounce.js": 64459,
	"./directive/direct/v-draggable": 52971,
	"./directive/direct/v-draggable.js": 52971,
	"./directive/direct/v-scroll": 57660,
	"./directive/direct/v-scroll.js": 57660,
	"./directive/direct/v-shuibowen": 73131,
	"./directive/direct/v-shuibowen.js": 73131,
	"./directive/index": 90973,
	"./directive/index.js": 90973,
	"./http": 11063,
	"./http/": 11063,
	"./http/index": 11063,
	"./http/index.js": 11063,
	"./i18n": 86926,
	"./i18n/": 86926,
	"./i18n/i18nOption": 17292,
	"./i18n/i18nOption.json": 17292,
	"./i18n/index": 86926,
	"./i18n/index.js": 86926,
	"./i18n/json/Chs": 15077,
	"./i18n/json/Chs.json": 15077,
	"./i18n/json/En": 74030,
	"./i18n/json/En.json": 74030,
	"./main": 43217,
	"./main.js": 43217,
	"./mixins/anim": 82568,
	"./mixins/anim.js": 82568,
	"./router": 15092,
	"./router/": 15092,
	"./router/index": 15092,
	"./router/index.js": 15092,
	"./store": 68854,
	"./store/": 68854,
	"./store/index": 68854,
	"./store/index.js": 68854,
	"./store/modules/achievements": 73232,
	"./store/modules/achievements.js": 73232,
	"./store/modules/airdrop": 28913,
	"./store/modules/airdrop.js": 28913,
	"./store/modules/appcenter": 25282,
	"./store/modules/appcenter.js": 25282,
	"./store/modules/assets": 91407,
	"./store/modules/assets.js": 91407,
	"./store/modules/autobot": 54855,
	"./store/modules/autobot.js": 54855,
	"./store/modules/bioMatrixScan": 64335,
	"./store/modules/bioMatrixScan.js": 64335,
	"./store/modules/daily": 51572,
	"./store/modules/daily.js": 51572,
	"./store/modules/deposit": 22881,
	"./store/modules/deposit.js": 22881,
	"./store/modules/lottery": 43136,
	"./store/modules/lottery.js": 43136,
	"./store/modules/lucky": 30457,
	"./store/modules/lucky.js": 30457,
	"./store/modules/luckybox": 54573,
	"./store/modules/luckybox.js": 54573,
	"./store/modules/mine": 40821,
	"./store/modules/mine.js": 40821,
	"./store/modules/ranking": 51734,
	"./store/modules/ranking.js": 51734,
	"./store/modules/squad": 20849,
	"./store/modules/squad.js": 20849,
	"./store/modules/task": 72390,
	"./store/modules/task.js": 72390,
	"./store/modules/user": 69220,
	"./store/modules/user.js": 69220,
	"./store/modules/wallet": 9944,
	"./store/modules/wallet.js": 9944,
	"./tonWallet": 88929,
	"./tonWallet/": 88929,
	"./tonWallet/index": 88929,
	"./tonWallet/index.js": 88929,
	"./utils": 1474,
	"./utils/": 1474,
	"./utils/errcode": 48956,
	"./utils/errcode.js": 48956,
	"./utils/errcode302": 22667,
	"./utils/errcode302.js": 22667,
	"./utils/formatter": 83291,
	"./utils/formatter.js": 83291,
	"./utils/game/2048/constants": 27480,
	"./utils/game/2048/constants.js": 27480,
	"./utils/game/aaGame/constants": 527,
	"./utils/game/aaGame/constants.js": 527,
	"./utils/game/bubbleShooter/audioManager": 54130,
	"./utils/game/bubbleShooter/audioManager.js": 54130,
	"./utils/game/bubbleShooter/canvasLoop": 2132,
	"./utils/game/bubbleShooter/canvasLoop.js": 2132,
	"./utils/game/bubbleShooter/constants": 88560,
	"./utils/game/bubbleShooter/constants.js": 88560,
	"./utils/game/circleMerge/audioManager": 75455,
	"./utils/game/circleMerge/audioManager.js": 75455,
	"./utils/game/circleMerge/constants": 63229,
	"./utils/game/circleMerge/constants.js": 63229,
	"./utils/game/fruitRush/audioService": 48357,
	"./utils/game/fruitRush/audioService.js": 48357,
	"./utils/game/fruitRush/constants": 11520,
	"./utils/game/fruitRush/constants.js": 11520,
	"./utils/game/fruitRush/types": 44356,
	"./utils/game/fruitRush/types.js": 44356,
	"./utils/game/sheep/constants": 33145,
	"./utils/game/sheep/constants.js": 33145,
	"./utils/game/sheep/gameLogic": 4515,
	"./utils/game/sheep/gameLogic.js": 4515,
	"./utils/game/sheep/types": 23008,
	"./utils/game/sheep/types.js": 23008,
	"./utils/game/tapUp/audioManager": 57348,
	"./utils/game/tapUp/audioManager.js": 57348,
	"./utils/game/tapUp/constants": 41682,
	"./utils/game/tapUp/constants.js": 41682,
	"./utils/game/tileConnect/audioService": 55195,
	"./utils/game/tileConnect/audioService.js": 55195,
	"./utils/game/tileConnect/constants": 90471,
	"./utils/game/tileConnect/constants.js": 90471,
	"./utils/game/tileConnect/gameLogic": 92135,
	"./utils/game/tileConnect/gameLogic.js": 92135,
	"./utils/game/zenBlocks/constants": 50771,
	"./utils/game/zenBlocks/constants.js": 50771,
	"./utils/gameAdv": 25534,
	"./utils/gameAdv.js": 25534,
	"./utils/index": 1474,
	"./utils/index.js": 1474,
	"./view": 65581,
	"./view/": 65581,
	"./view/BioMatrix": 7125,
	"./view/BioMatrix.vue": 7125,
	"./view/CodexFieldWallet": 40653,
	"./view/CodexFieldWallet.vue": 40653,
	"./view/DailyInvite": 72047,
	"./view/DailyInvite.vue": 72047,
	"./view/achievements": 97591,
	"./view/achievements.vue": 97591,
	"./view/activity": 42430,
	"./view/activity.vue": 42430,
	"./view/airdrop": 23686,
	"./view/airdrop.vue": 23686,
	"./view/airdropFirst": 80936,
	"./view/airdropFirst.vue": 80936,
	"./view/airdropInviter": 27563,
	"./view/airdropInviter.vue": 27563,
	"./view/airdropReward": 21711,
	"./view/airdropReward.vue": 21711,
	"./view/airdropSecond": 16733,
	"./view/airdropSecond.vue": 16733,
	"./view/appcenter": 92304,
	"./view/appcenter.vue": 92304,
	"./view/avatar": 80735,
	"./view/avatar.vue": 80735,
	"./view/bioMatrixScan": 1171,
	"./view/bioMatrixScan.vue": 1171,
	"./view/bioMatrixScanDetail": 86880,
	"./view/bioMatrixScanDetail.vue": 86880,
	"./view/bioMatrixScanInvite": 1706,
	"./view/bioMatrixScanInvite.vue": 1706,
	"./view/bitgetWallet": 52529,
	"./view/bitgetWallet.vue": 52529,
	"./view/bitgetWalletAirdrop": 69415,
	"./view/bitgetWalletAirdrop.vue": 69415,
	"./view/blind": 80585,
	"./view/blind.vue": 80585,
	"./view/boost": 38687,
	"./view/boost.vue": 38687,
	"./view/code": 84016,
	"./view/code.vue": 84016,
	"./view/depositDetail": 6919,
	"./view/depositDetail.vue": 6919,
	"./view/earn": 6131,
	"./view/earn.vue": 6131,
	"./view/forturn": 64615,
	"./view/forturn.vue": 64615,
	"./view/frens": 2673,
	"./view/frens.vue": 2673,
	"./view/game": 96092,
	"./view/game/": 96092,
	"./view/game/2048": 24698,
	"./view/game/2048.vue": 24698,
	"./view/game/aaGame": 65630,
	"./view/game/aaGame.vue": 65630,
	"./view/game/bubbleShooter": 97350,
	"./view/game/bubbleShooter.vue": 97350,
	"./view/game/circleMerge": 11839,
	"./view/game/circleMerge.vue": 11839,
	"./view/game/fruitRush": 86990,
	"./view/game/fruitRush.vue": 86990,
	"./view/game/index": 96092,
	"./view/game/index.vue": 96092,
	"./view/game/rank": 71322,
	"./view/game/rank.vue": 71322,
	"./view/game/sheep": 97704,
	"./view/game/sheep.vue": 97704,
	"./view/game/tapUp": 57465,
	"./view/game/tapUp.vue": 57465,
	"./view/game/tileConnect": 66056,
	"./view/game/tileConnect.vue": 66056,
	"./view/game/zenBlocks": 34534,
	"./view/game/zenBlocks.vue": 34534,
	"./view/giftInventory": 84028,
	"./view/giftInventory.vue": 84028,
	"./view/giftLucky": 62792,
	"./view/giftLucky.vue": 62792,
	"./view/gifts": 51144,
	"./view/gifts.vue": 51144,
	"./view/index": 65581,
	"./view/index.vue": 65581,
	"./view/join": 95344,
	"./view/join.vue": 95344,
	"./view/lottery": 95319,
	"./view/lottery.vue": 95319,
	"./view/lotteryDetail": 15395,
	"./view/lotteryDetail.vue": 15395,
	"./view/lucky": 38329,
	"./view/lucky.vue": 38329,
	"./view/luckyBox": 8881,
	"./view/luckyBox.vue": 8881,
	"./view/luckyBoxNew": 6679,
	"./view/luckyBoxNew.vue": 6679,
	"./view/mine": 50837,
	"./view/mine.vue": 50837,
	"./view/mpay": 8569,
	"./view/mpay.vue": 8569,
	"./view/nftInfo": 42467,
	"./view/nftInfo.vue": 42467,
	"./view/nftInvite": 59038,
	"./view/nftInvite.vue": 59038,
	"./view/nftLucky": 28440,
	"./view/nftLucky.vue": 28440,
	"./view/nftdetail": 62361,
	"./view/nftdetail.vue": 62361,
	"./view/nfts": 55663,
	"./view/nfts.vue": 55663,
	"./view/okxWallet": 13320,
	"./view/okxWallet.vue": 13320,
	"./view/pph": 33297,
	"./view/pph.vue": 33297,
	"./view/rank": 75592,
	"./view/rank.vue": 75592,
	"./view/sign": 75507,
	"./view/sign.vue": 75507,
	"./view/slotMachine": 12994,
	"./view/slotMachine.vue": 12994,
	"./view/solojack": 69845,
	"./view/solojack.vue": 69845,
	"./view/squad": 93154,
	"./view/squad.vue": 93154,
	"./view/taskDetail": 28780,
	"./view/taskDetail.vue": 28780,
	"./view/usdEvent": 83179,
	"./view/usdEvent.vue": 83179,
	"./view/usdLucky": 8818,
	"./view/usdLucky.vue": 8818,
	"./view/wallet": 4605,
	"./view/wallet.vue": 4605,
	"./view/walletDetail": 17188,
	"./view/walletDetail.vue": 17188,
	"./view/withdraw": 5677,
	"./view/withdraw.vue": 5677,
	"./view/youtube": 33452,
	"./view/youtube.vue": 33452,
	"./web3Wallet": 79305,
	"./web3Wallet/": 79305,
	"./web3Wallet/config/config": 7935,
	"./web3Wallet/config/config.json": 7935,
	"./web3Wallet/config_for_test/config": 94175,
	"./web3Wallet/config_for_test/config.json": 94175,
	"./web3Wallet/contracts/market": 37496,
	"./web3Wallet/contracts/market.json": 37496,
	"./web3Wallet/contracts/market_old": 64409,
	"./web3Wallet/contracts/market_old.json": 64409,
	"./web3Wallet/contracts_for_test/market": 30551,
	"./web3Wallet/contracts_for_test/market.json": 30551,
	"./web3Wallet/contracts_for_test/market_old": 4076,
	"./web3Wallet/contracts_for_test/market_old.json": 4076,
	"./web3Wallet/index": 79305,
	"./web3Wallet/index.js": 79305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;